export default __webpack_public_path__ + "static/media/sachsen_dark.0094eae3.png";